import React from 'react';

export const LeftArrowIcon = () => {
  return (
    <svg
      width="78"
      height="79"
      viewBox="0 0 78 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_bd_6493_26752)">
        <rect
          x="15"
          y="5.94446"
          width="48"
          height="48"
          rx="24"
          fill="url(#paint0_radial_6493_26752)"
          fillOpacity="0.15"
          shapeRendering="crispEdges"
        />
        <rect
          x="15"
          y="5.94446"
          width="48"
          height="48"
          rx="24"
          fill="url(#paint1_linear_6493_26752)"
          fillOpacity="0.2"
          shapeRendering="crispEdges"
        />
        <rect
          x="15.25"
          y="6.19446"
          width="47.5"
          height="47.5"
          rx="23.75"
          stroke="url(#paint2_linear_6493_26752)"
          strokeWidth="0.5"
          shapeRendering="crispEdges"
        />
        <path
          d="M47 28.9445H34.83L40.42 23.3545L39 21.9445L31 29.9445L39 37.9445L40.41 36.5345L34.83 30.9445H47V28.9445Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_bd_6493_26752"
          x="-80"
          y="-89.0555"
          width="238"
          height="238"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="47.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_6493_26752"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_backgroundBlur_6493_26752"
            result="effect2_dropShadow_6493_26752"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_6493_26752"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_6493_26752"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-5.42115 -15.5292) rotate(94.3635) scale(52.5734)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_6493_26752"
          x1="15.617"
          y1="7.0064"
          x2="62.9887"
          y2="52.6819"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6493_26752"
          x1="15"
          y1="7.43118"
          x2="61.8841"
          y2="52.251"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
